import { Modal } from "react-bootstrap";
import { useState } from "react";


export default function SavePopUpModal(props) {
    const {
        showModal,
        handleClose,
        onViewClick,
        onClickDownload
    } = props
    const [showPop, setShow] = useState(showModal)
    return (

        <Modal
            show={showPop}
            size="lg md sm xs"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="savePopUp"
            scrollable={true}
        >
            <div>
                <div style={{ padding: "0 5%" }}>
                    <Modal.Header >
                        <div style={{ textAlign: "left" }}>
                            <Modal.Title>
                                <span className="gen-ai-gsf-saveModal-heading">Select your preference to view the results</span>
                            </Modal.Title>
                        </div>
                    </Modal.Header>
                    <div className="gen-ai-gsf-saveModal-popup__footer">
                       {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') &&  <button
                            type="button"
                            className="gen-ai-gsf-popup__btn gen-ai-gsf-popup__btn--primary"
                            onClick={() => { setShow(false); handleClose(false); onViewClick() }}
                        >
                            View
                        </button>}
                        <button
                            type="button"
                            className="gen-ai-gsf-popup__btn gen-ai-gsf-popup__btn--primary"
                            onClick={() => { setShow(false); handleClose(false); onClickDownload() }}
                        >
                            Download
                        </button>
                        <button
                            type="button"
                            className="gen-ai-gsf-popup__btn gen-ai-gsf-popup__btn--outline"
                            onClick={() => { setShow(false); handleClose(false) }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}